import { Component } from '@angular/core';
import { LoaderService } from 'src/app/services/loader/loader.service';
import { NavController } from '@ionic/angular';
import { AreaService } from 'src/app/services/Area/area.service';

@Component({
  selector: 'app-tabs',
  templateUrl: 'tabs.page.html',
  styleUrls: ['tabs.page.scss']
})
export class TabsPage {

  constructor(
    public loader:LoaderService,
    private navCtrl:NavController,
    public areaService:AreaService,
  ){

  }

  home(){
    this.navCtrl.navigateRoot('/app/home');
    this.loader.page = "home";
  }
  about(){
    this.navCtrl.navigateForward('/app/about');
    this.loader.page = "about";
  }
  contact(){
    this.navCtrl.navigateForward('/app/contact');
    this.loader.page = "contact";
  }

}
